/* eslint-disable @typescript-eslint/no-floating-promises */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../../api/Api";

export const userLogin = createAsyncThunk(
  "user/login",
  async (
    { username, password, remember }: any,
    { rejectWithValue, dispatch },
  ) => {
    try {
      // configure header's Content-Type as JSON
      console.log("here userLogin");
      const { data } = await API.login(username, password, remember);
      dispatch(getUserInfo());
      // console.log('userLogin', data)
      // // store user's token in local storage
      // localStorage.setItem('accessToken', data.access_token)
      return data;
    } catch (error: any) {
      // return custom error message from API if any
      if (error?.response?.data?.message != null) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const userLogout = createAsyncThunk(
  "user/logout",
  async (_, { rejectWithValue }) => {
    try {
      // configure header's Content-Type as JSON
      await API.logout();
    } catch (error: any) {
      // return custom error message from API if any
      if (error?.response?.data?.message != null) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const userRefresh = createAsyncThunk(
  "user/refresh",
  async (_, { rejectWithValue }) => {
    try {
      // configure header's Content-Type as JSON
      await API.refreshToken();
    } catch (error: any) {
      // return custom error message from API if any
      if (error?.response?.data?.message != null) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const getUserInfo = createAsyncThunk(
  "user/me",
  async (_, { rejectWithValue }) => {
    console.log("getUserInfo");

    try {
      // configure header's Content-Type as JSON
      const { data } = await API.getUser();
      // store user's token in local storage
      // localStorage.setItem('accessToken', data.accessToken)
      return data;
    } catch (error: any) {
      // return custom error message from API if any
      if (error?.response?.data?.message != null) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

// export const registerUser = createAsyncThunk(
//   'user/register',
//   async ({ firstName, email, password }, { rejectWithValue }) => {
//     try {
//       const config = {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       }

//       await axios.post(
//         `${backendURL}/api/user/register`,
//         { firstName, email, password },
//         config
//       )
//     } catch (error) {
//       if (error.response && error.response.data.message) {
//         return rejectWithValue(error.response.data.message)
//       } else {
//         return rejectWithValue(error.message)
//       }
//     }
//   }
// )
